import React, { useState } from "react";
import { ArrowBtnHLPure, ButtonAddHLPure, ButtonHLPure, DialogSystemGLPure, DropDownBtnHLPure, InputHLPure, Label, SimpleLoading, TextAreaHLPure } from "../../pures";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RegistrationValidator } from "../../../validators";
import { countriesList } from "../../../utils";
import "./contractors-catalog-detail.view.css"
import { useEffect } from "react";
import { ContractorService } from "../../../services";

const ContractorsCatalogEditView = (props) => {

    const { t } = useTranslation();
    const validations = RegistrationValidator(t)
    const history = useHistory();

    let {
        hideShowDetails,
        url,
        token,
        isLoadingView,
        validator,
        nameComponentUser,
        showLoadingRequesting,
        showCompletedRequesting,
        showErrorRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting,
        toggleCompletedRequesting,
        toggleLoadingScreen,
        message,
        typePersonDropDown,
        sendOtherPage,
        backGridView,
        dateModified,
        contractorGridSelected,
        getConractorsForService,
        setImagetitle,
        logoFile,
        setLogoFile
    } = props

    const [typePerson, setTypePerson] = useState(2)
    const [tipePersonValue, setTipePersonValue] = useState(2)
    const [businessName, setBussinessName] = useState('')
    const [errorBusinessName, setErrorBusinessName] = useState(false)
    const [name, setName] = useState('')
    const [errorName, setErrorName] = useState(false)
    const [rfc, setRfc] = useState('')
    const [errorRfc, setErrorRfc] = useState(false)
    const [curp, setCurp] = useState(false)
    const [errorCurp, setErrorCurp] = useState(false)
    const [address, setAddress] = useState('')
    const [errorAddress, setErrorAddress] = useState(false)
    const [city, setCity] = useState('')
    const [errorCity, setErrorCity] = useState(false)
    const [stateCity, setStateCity] = useState('')
    const [errorState, setErrorState] = useState(false)
    const [cp, setCp] = useState('')
    const [errorCp, setErrorCp] = useState(false)
    const [valueDropCountry, setValueDropCountry] = useState('México')
    const [countrySelected, setCountrySelected] = useState('México')
    const [contractorInfo, setContractorInfo] = useState({})
    const [labelModified, setLabelModified] = useState('')


    const contractorService = new ContractorService(url)

    useEffect(() => {
        if (nameComponentUser !== t("contractorsCatalogView-btn-details")) return

        toggleLoadingRequesting(true)
        setValueDropCountry(contractorGridSelected.country)
        setTipePersonValue(contractorGridSelected.contractorPersonTypeId)
        setTypePerson(contractorGridSelected.contractorPersonTypeId)
        setBussinessName(contractorGridSelected.name)
        setRfc(contractorGridSelected.rfc)
        setName(contractorGridSelected.name)
        setCurp(contractorGridSelected.curp)
        setAddress(contractorGridSelected.contractorStreet)
        setCity(contractorGridSelected.contractorTownship)
        setStateCity(contractorGridSelected.contractorState)
        setCp(contractorGridSelected.contractorZipCode)
        setContractorInfo(contractorGridSelected)
        setImagetitle(contractorGridSelected.logo)
        let user = (contractorGridSelected && contractorGridSelected.updatedByUser && contractorGridSelected.updatedByUser !== '') ? contractorGridSelected.updatedByUser : ''
        let date = (contractorGridSelected && contractorGridSelected.date && contractorGridSelected.date !== '') ? ` el ${contractorGridSelected.date}` : ''
        let label = `Modificado por ${user}  ${date}`
        setLabelModified(label)
        toggleLoadingRequesting(false)

    }, [contractorGridSelected])


    const handleDropDownChangePerson = (e) => {
        setTypePerson(Number(e.target.value))
    }

    const onChangeBussinessName = (e) => {
        setBussinessName(e.target.value)
        setErrorBusinessName(false)
    }

    const onChangeName = (e) => {
        setName(e.target.value)
        setErrorName(false)
    }

    const onChangeRfc = (e) => {
        setErrorRfc(false)
        setRfc((e.target.value).toUpperCase())
    }

    const onChangeCurp = (e) => {
        setCurp((e.target.value).toUpperCase())
        setErrorCurp(false)
    }

    const onChangeAddress = (e) => {
        setAddress(e.target.value)
        setErrorAddress(false)
    }

    const onChangeCity = (e) => {
        setCity(e.target.value)
        setErrorCity(false)
    }

    const onChangeState = (e) => {
        setStateCity(e.target.value)
        setErrorState(false)
    }

    const onChangeCP = (e) => {
        setCp(e.target.value)
        setErrorCp(false)
    }

    const handleValidateRFCMoral = () => {
        let validRFCMoral = validations.moralRfcValidator(rfc)
        if (validRFCMoral !== '') {
            setErrorRfc(true)
        }
    }

    const handleValidateRFCFisico = () => {
        let validateRfc = validations.rfcValidator(rfc)
        if (validateRfc !== '') {
            setErrorRfc(true)
        }
    }

    const handleDropDownChageCountries = (e) => {
        setCountrySelected(e.target.value)
    }


    //save info contractor
    const handleSaveInfo = async (e) => {
        let errorMessage = 'Ocurrió un erro al guardar la información del contratante'
        toggleLoadingRequesting(true)
        let personNumberMoralFisico = 0
        let businessNameMoral = ''
        let RFCMoralFisico = ''
        let nameFisico = ''
        let CURPFisico = ''

        //validate bussiness or name
        if (typePerson === 1) {

            //validate name
            if (name !== "") {
                let nameValid = validator.nameValidator(name);
                if (name === undefined || nameValid !== "") {
                    setErrorName(true)
                    return;
                }
            } else {
                setErrorName(true)
                return;
            }

            personNumberMoralFisico = typePerson
            nameFisico = name
            RFCMoralFisico = rfc
            CURPFisico = curp
        }


        if (typePerson === 2) {
            if (businessName === '') {
                setErrorBusinessName(true)
                return;
            }

            personNumberMoralFisico = typePerson
            nameFisico = businessName
            RFCMoralFisico = rfc
        }

        //set info to send
        let contractorCountry = countrySelected ? countrySelected : 'México'
        let id = contractorInfo.id
        let contractorPersonTypeId = personNumberMoralFisico
        let nameSend = nameFisico
        let rfcSend = RFCMoralFisico
        let curpSend = CURPFisico
        let limitDate = contractorInfo.limitDate
        let notes = contractorInfo.notes
        let contractorStreet = address
        let contractorTownship = city
        let contractorState = stateCity
        let contractorZipCode = cp

        try {
            let solicitudId = `${contractorGridSelected.id}`
            if (logoFile && logoFile.name) {
                let logo = new FormData();
                logo.append("logo", logoFile);
                logo.append("id", solicitudId);
                let updateLogo = await contractorService.updateLogoContractor(logo, token)
                if (!updateLogo || !updateLogo.data || Number(updateLogo.statusCode) !== 200) {
                    toggleLoadingRequesting(false)
                    toggleErrorRequesting(true, errorMessage, 4000, false)
                    return
                }
                setLogoFile(null)
            }

            let updateContractor = await contractorService.updateContractor(id, contractorPersonTypeId, nameSend, rfcSend, curpSend, limitDate, notes, contractorStreet, contractorTownship, contractorState, contractorZipCode, contractorCountry, solicitudId, token)
            if (updateContractor && updateContractor.data && updateContractor.data.data && Number(updateContractor.data.statusCode) === 200) {
                getConractorsForService(backGridView)
            } else {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, errorMessage, 4000, false)
            }
        } catch (error) {
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true, errorMessage, 4000, false)
        }
    }



    return (
        <div className="contractorsCatalogDetailView-wrapper">
            {
                isLoadingView ? (
                    <SimpleLoading />
                ) :
                    (
                        <>
                            <div className="contractorsCatalogDetailView-container">
                                {showLoadingRequesting ? (<DialogSystemGLPure showLoadingRequesting={showLoadingRequesting} toggleLoadingRequesting={toggleLoadingRequesting} />) : null}
                                {showErrorRequesting ? (<DialogSystemGLPure showErrorRequesting={showErrorRequesting} toggleErrorRequesting={toggleErrorRequesting} message={message} />) : null}
                                {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}

                                <Grid container lg={12} md={12} sm={12} xs={12}>
                                    <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="contractorsCatalogDetailView-container-inputs"
                                    >
                                        <Grid
                                            item
                                            lg={6}
                                            md={6}
                                            sm={12}
                                            xs={12}
                                            className="contractorsCatalogDetailView-container-left"
                                        >
                                            <div className="contractorsCatalogDetailView-continer-type-person">
                                                <DropDownBtnHLPure
                                                    labelDropDown={t('contractingRegistrationDataView.dropdown.label.type.person')}
                                                    optionsDropDown={typePersonDropDown}
                                                    onDropDownChange={(e) => handleDropDownChangePerson(e)}
                                                    optionsValue={tipePersonValue}
                                                    valueItem={"id"}
                                                    nameOption={"name"}
                                                />
                                            </div>
                                            {
                                                typePerson === 0 || typePerson === 2
                                                    ? <>
                                                        <div className="contractorsCatalogDetailView-container-name">
                                                            <InputHLPure
                                                                typeInput="text"
                                                                labelInput={t('contractingRegistrationDataView.input.label.bussiness.name') + " *"}
                                                                valueInput={businessName}
                                                                handleChangeInput={(e) => onChangeBussinessName(e)}
                                                                tooltipShow
                                                                positionTooltip={'right'}
                                                                titleTooltip={t('contractingRegistrationDataView.input.label.bussiness.name')}
                                                                descriptionTooltip={t('contractingRegistrationDataView.input.bussiness.name.tooltip.description')}
                                                                subContent={''}
                                                                informationIcon={true}
                                                                inputActive={true}
                                                                inputTypeBox={false}
                                                            />
                                                            {errorBusinessName && (
                                                                <span className="hint-message-error">
                                                                    {t('contractingRegistrationDataView.input.bussiness.name.error')}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="contractorsCatalogDetailView-container-rfc">
                                                            <InputHLPure
                                                                typeInput="text"
                                                                labelInput={
                                                                    t("taxDataInvoaInvoicingView.rfc")
                                                                }
                                                                valueInput={rfc}
                                                                handleChangeInput={(e) => onChangeRfc(e)}
                                                                tooltipShow={false}
                                                                informationIcon={false}
                                                                inputActive={true}
                                                                onBlur={handleValidateRFCMoral}
                                                                inputTypeBox={false}
                                                            />
                                                            {errorRfc && (
                                                                <span className="hint-message-error">
                                                                    {t("taxDataInvoincingValidator.errorRFC")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </>
                                                    : <>
                                                        <div className="contractorsCatalogDetailView-container-name">
                                                            <InputHLPure
                                                                typeInput="text"
                                                                labelInput={t('contractingRegistrationDataView.input.name.label') + " *"}
                                                                valueInput={name}
                                                                handleChangeInput={(e) => onChangeName(e)}
                                                                tooltipShow
                                                                positionTooltip={'right'}
                                                                titleTooltip={t('contractingRegistrationDataView.input.name.label')}
                                                                descriptionTooltip={t('contractingRegistrationDataView.input.name.tooltip.description')}
                                                                subContent={''}
                                                                informationIcon={true}
                                                                inputActive={true}
                                                                onBlur={handleValidateRFCFisico}
                                                                inputTypeBox={false}
                                                            />
                                                            {errorName && (
                                                                <span className="hint-message-error">
                                                                    {t('contractingRegistrationDataView.input.name.error')}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="contractorsCatalogDetailView-container-rfc">
                                                            <InputHLPure
                                                                typeInput="text"
                                                                labelInput={
                                                                    t("taxDataInvoaInvoicingView.rfc")
                                                                }
                                                                valueInput={rfc}
                                                                handleChangeInput={(e) => onChangeRfc(e)}
                                                                tooltipShow={false}
                                                                informationIcon={false}
                                                                inputActive={true}
                                                                inputTypeBox={false}
                                                            />
                                                            {errorRfc && (
                                                                <span className="hint-message-error">
                                                                    {t("taxDataInvoincingValidator.errorRFC")}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="contractorsCatalogDetailView-container-rfc">
                                                            <InputHLPure
                                                                typeInput="text"
                                                                labelInput={t('contractingRegistrationDataView.input.curp.label')}
                                                                valueInput={curp}
                                                                handleChangeInput={(e) => onChangeCurp(e)}
                                                                tooltipShow={false}
                                                                informationIcon={false}
                                                                inputActive={true}
                                                                inputTypeBox={false}
                                                            />
                                                            {errorCurp && (
                                                                <span className="hint-message-error">
                                                                    {t('contractingRegistrationDataView.input.curp.error')}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </>

                                            }
                                            <div className="">
                                                <DropDownBtnHLPure
                                                    labelDropDown={t('contractingRegistrationDataView.dropdown.label.countries')}
                                                    optionsDropDown={countriesList}
                                                    valueItem={"country"}
                                                    nameOption={"country"}
                                                    optionsValue={valueDropCountry}
                                                    onDropDownChange={(e) => handleDropDownChageCountries(e)}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid
                                            item
                                            lg={6}
                                            md={6}
                                            sm={12}
                                            xs={12}
                                            className="contractorsCatalogDetailView-container-right"
                                        >
                                            <div className="contractorsCatalogDetailView-container-address">
                                                <TextAreaHLPure
                                                    labelTextArea={t('contractorsCatalogDetailView.address.label')}
                                                    valueTextData={address}
                                                    handleChangeTextArea={(e) => onChangeAddress(e)}
                                                />
                                            </div>
                                            <div className="contractorsCatalogDetailView-container-city">
                                                <InputHLPure
                                                    typeInput="text"
                                                    labelInput={t('contractingRegistrationDataView.input.city.label')}
                                                    valueInput={city}
                                                    handleChangeInput={(e) => onChangeCity(e)}
                                                    tooltipShow={false}
                                                    informationIcon={false}
                                                    inputActive={true}
                                                    inputTypeBox={false}
                                                />
                                                {errorCity && (
                                                    <span className="hint-message-error">
                                                        {t('contractingRegistrationDataView.input.city.error')}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="contractorsCatalogDetailView-container-state">
                                                <InputHLPure
                                                    typeInput="text"
                                                    labelInput={t('contractingRegistrationDataView.input.state.label')}
                                                    valueInput={stateCity}
                                                    handleChangeInput={(e) => onChangeState(e)}
                                                    tooltipShow={false}
                                                    informationIcon={false}
                                                    inputActive={true}
                                                    inputTypeBox={false}
                                                />
                                                {errorState && (
                                                    <span className="hint-message-error">
                                                        {t('contractingRegistrationDataView.input.state.error')}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="contractorsCatalogDetailView-container-cp">
                                                <InputHLPure
                                                    typeInput="text"
                                                    labelInput={t('contractingRegistrationDataView.input.cp.label')}
                                                    valueInput={cp}
                                                    handleChangeInput={(e) => onChangeCP(e)}
                                                    tooltipShow={false}
                                                    informationIcon={false}
                                                    inputActive={true}
                                                    inputTypeBox={false}
                                                />
                                                {errorCp && (
                                                    <span className="hint-message-error">
                                                        {t('contractingRegistrationDataView.input.cp.error')}
                                                    </span>
                                                )}
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <div className="contractorsCatalogDetailView-container-label-modified">
                                        <p>
                                            {labelModified}
                                        </p>
                                    </div>
                                </Grid>
                            </div>
                            <div className="contractorsCatalogDetailView-container-btns">
                                <div className="contractorsCatalogDetailView-secondaty-btn">
                                    <ButtonHLPure
                                        nameBtn={'Cancelar'}
                                        primary={false}
                                        onClickBtn={backGridView}
                                    />
                                </div>
                                <div className="contractorsCatalogDetailView-arrow-btn">
                                    <ArrowBtnHLPure
                                        textArrowBtn={t("contractorsCatalogView-btn-disable")}
                                        onClickArrowBtn={(e) => sendOtherPage(t("contractorsCatalogView-btn-disable"), e)}
                                        dataSetProp={t("contractorsCatalogView-btn-disable")}
                                        primary={false}
                                    />
                                </div>
                                {/* <div className="contractorsCatalogDetailView-arrow-btn">
                            <ArrowBtnHLPure
                                textArrowBtn={t("contractorsCatalogView-btn-additional-data")}
                                onClickArrowBtn={(e) => sendOtherPage(t("contractorsCatalogView-btn-additional-data"), e)}
                                dataSetProp={t("contractorsCatalogView-btn-additional-data")}
                                primary={false}
                            />
                        </div> */}
                                <div className="contractorsCatalogDetailView-arrow-btn">
                                    <ArrowBtnHLPure
                                        textArrowBtn={t("contractorsCatalogView-btn-sort")}
                                        onClickArrowBtn={(e) => sendOtherPage(t("contractorsCatalogView-btn-sort"), e)}
                                        dataSetProp={t("contractorsCatalogView-btn-sort")}
                                        primary={false}
                                    />
                                </div>
                                 <div className="contractorsCatalogDetailView-arrow-btn">
                                    <ArrowBtnHLPure
                                        textArrowBtn={t("contractorsCatalogView.watch.document")}
                                        onClickArrowBtn={(e) => sendOtherPage(t("contractorsCatalogView.watch.document"), e)}
                                        dataSetProp={t("contractorsCatalogView.watch.document")}
                                        primary={false}
                                    />
                                </div>
                                <ButtonHLPure
                                    nameBtn={t("button.save")}
                                    primary={true}
                                    onClickBtn={(event) => handleSaveInfo(event)}
                                />
                            </div>
                        </>
                    )
            }
        </div>
    );
}

export default ContractorsCatalogEditView